<template>
	<div :class="(isShow ? 'opacityBgUnshow' : 'opacityBgShow') +'  navigation' "  >
		<ul class="box" >
			<li class="item5" v-on:click="isShow = !isShow" :style="{background: isShow ? '#d91748' : '#d91748' }" ><span  ></span></li>
			
			<!-- <div class="itemBox" > -->
				<transition-group name="slide-fade">
					<li v-if="isShow" v-on:click="handleNav(item.nav,true)" :class="'item'+(index+1)+' item'" v-for="(item,index) in list" :key="item.id"  ><div :style="{backgroundColor:item.isShow?'rgba(0,0,0,0.2)': 'rgba(0,0,0,0.8)'}" >{{item.name}} </div></li>
				</transition-group>
			<!-- </div> -->
			
		</ul>
	</div>
</template>
<script>
    export default {
        data(){
            return {
				isShow:false,
				list:[
					{name:'国际人才港',id:1,isShow:false,nav:'scene_hp-1-t'},
					{name:'研创园',id:2,isShow:false,nav:'scene_hp-3-y'},
					{name:'人工智能岛',id:3,isShow:false,nav:'scene_hp3g-k'},
					{name:'园区总览',id:4,isShow:true,nav:'scene_hp-n'},
				],
				update:false
            }
        },
        mounted(){
			window.vtour.handleNav = this.handleNav
		},
        methods:{
			handleNav(nav,isToH5){
				if(this.$parent.krpano.get('xml').scene === nav){

				} else{
					this.$parent.editTittle(nav)
					this.list.forEach(item=>{
						if(item.nav === nav){
							item.isShow= true
						} else {
							item.isShow = false
						}
					})
					this.$parent.isShowTower(false)
					this.update = !this.update
					if(isToH5){
						krpano.call("set(layer[lefttop_icon05].crop, '1500|100|100|100');");
						this.$parent.krpano.call('toscene1(false,'+nav+')')
						if(nav === 'scene_hp-1-t'){
							this.$parent.getTowerState(100)
						} else if( nav == 'scene_hp-3-y'){
							this.$parent.getTowerState(101)
						} else if( nav == 'scene_hp3g-k'){
							this.$parent.getTowerState(102)
						} else {

						}
						
					}
					
				}
				
			}
        },
        components:{
        }
    }
</script>
<style scoped lang="scss" >
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
	transition: all .2s ease;
	}
	.slide-fade-leave-active {
	transition: all .2s ease;
	}
	.slide-fade-enter, .slide-fade-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
	transform: translateX(40px);
		opacity: 0;
	}
	.opacityBgShow{
		-moz-transform: all 2s ease;
		-webkit-transform: all 2s ease;
		background:rgba(255,255,255,0) !important;
	}
	.opacityBgUnshow{
		-moz-transform: all 2s ease;
		-webkit-transform: all 2s ease;
		background:rgba(255,255,255,1) !important;
	}
    .navigation{
			position: fixed;
			z-index: 100;
			bottom: 20px;
			right: 5px;	
			background:rgba(255,255,255,0.5);
			padding:10px;
			padding-left:0px;
			// opacity: 0.9;
			
			border-radius:5px;
			font-size:12px;
			color:#fff;
		}
		.navigation ul li{
			float:right;
			overflow:hidden;
			cursor: pointer;
		}
		.itemBox{
			// position:absolute;
		}
		.box .item5{
			// position:absolute;
			left:10px;
			color:#000;
			width:46px;
			height:46px;
			// border:1px #ccc solid;
			margin-top:7px;
			margin-bottom: 7px;
			border-radius:50%;
			// padding:10px;
			box-sizing: border-box;
			span{
				display:block;
				width:36px;
				height:36px;
				background-size:100% 100%;
				background:url('../assets/newmenuIcon.png') 100% 100% no-repeat;
				
			}
		}
		.box .item1{
			width:60px;
			height:60px;
			background:url('../assets/t_park.png') no-repeat;
			background-size:100% 100%;
		}
		.box .item2{
			width:60px;
			height:60px;
			background:url('../assets/y_park.png') no-repeat;
			background-size:100% 100%;
		}
		.box .item3{
			width:60px;
			height:60px;
			background:url('../assets/k_park.png') no-repeat;
			background-size:100% 100%;
		}
		.box .item4{
			width:60px;
			height:60px;
			background:url('../assets/thumb.jpg') no-repeat;
			background-size:100% 100%;
		}
		ul li div{
			line-height:60px;
			width:60px;
			text-align:center;
			background:rgba(0,0,0,0.2)
		}
		ul li{
			margin-left:10px;
			border-radius:4px;
		}
</style>




// WEBPACK FOOTER //
// src/commonComponents/Navigation.vue